import styled from '@emotion/styled';
import { variant } from 'styled-system';
import { StyledProps as Props, Theme } from './Logo.types';

const color = (text: string, house: string) => ({
  '.text': {
    fill: text,
  },
  '.house': {
    fill: house,
  },
});

export default styled.svg<Props, Theme>`
  ${variant({
    variants: {
      light: color('var(--color-extra-white)', 'var(--color-vibrant-blue)'),
      normal: color('var(--color-indigo)', 'var(--color-vibrant-blue)'),
      dark: color('var(--color-indigo-t11)', 'var(--color-vibrant-blue)'),
    },
  })}
`;
